import React, { useEffect, useState } from 'react';
import './styles.scss';
import { strings } from '../../../../../util/strings';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    addToGlobalStyles,
    addToWizard,
    setWizard,
} from '../../../../../store/actions';
import NewAttachFiles from './attach-files/NewAttachFiles';

export interface NewInvoiceValidationProps {
    onSubmit(values: any): any;
    setValid(value: boolean): void;
    nextStep(): void;
    valid: boolean;
    wizard: any;
    setWizard(value: any): void;
    setOldFiles(files: any[]): void;
    addToWizard(value: any): void;
    addToGlobalStyles(value: any): void;
    labels: typeof strings.pt.createRefund;
    labelsPreAuthorizations: typeof strings.pt.preAuthorizations;
    showPopup: boolean;
    titleOfButton: string;
    selectedBu: any;
    nextStepFlag: boolean;
    labelFiles?: string;
    preAuth?: boolean;
}

function NewInvoiceValidation(props: NewInvoiceValidationProps) {
    const {
      labels,
      wizard,
      nextStep,
      showPopup,
      titleOfButton,
      nextStepFlag,
      labelFiles = labels?.createRefund_sendReceiptText,
      setOldFiles,
    } = props;
    const [sessionId, setSessionId] = useState<string>();

    if (!!wizard.attachFiles && !!!sessionId) {
        setSessionId(wizard.attachFiles.sessionId);
    }

    return (
        <NewAttachFiles
            {...props}
            titleOfButton={titleOfButton}
            showPopup={showPopup}
            nextStep={nextStep}
            selectedBu={props.selectedBu.buId}
            nextStepFlag={nextStepFlag}
            labelFiles={labelFiles}
            setOldFiles={(files: any[]) => setOldFiles(files)}
        />
    );
}

const mapStateToProps = ({ wizard, strings, selectedBu }: any) => ({
    wizard: wizard.value,
    labels: strings.value.pt.createRefund,
    labelsPreAuthorizations: strings.value.pt.preAuthorizations,
    selectedBu: selectedBu.value,
});

const mapDispatchToProps = (dispatch: any) => ({
    setWizard: (value: any) => dispatch(setWizard(value)),
    addToWizard: (value: any) => dispatch(addToWizard(value)),
    addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps)(NewInvoiceValidation)
);
